import { useSessionStorage } from 'react-use';
import type { SubscriptionTypeInput } from '@/gql/__codegen__/graphql';

/**
 * 3DS認証用クレジットカードフォーム値
 */
type CreditCard3dsFormValues = {
  cardNumber: string;
  cardHolderName: string;
  cardExpireMonth: string;
  cardExpireYear: string;
  cardSecurityCode: string;
};

/**
 * Escott 3DSトークン
 */
type Escott3dsToken = {
  token: string;
};

/**
 * パートナー連携用マージトークン
 */
type MergeToken = {
  mergeToken: string;
};

/**
 * セッションストレージkey型定義
 */
type SessionStorageKeys = {
  userCreate: {
    mailAddress: string;
    password: string;
  };
  userCreateUserInfo: {
    userPlatformId: string;
    multiAccountId: string;
  };
  userCreate3dsFormValues: CreditCard3dsFormValues;
  userCreate3dsEscottToken: Escott3dsToken;
  apply3dsFormValues: CreditCard3dsFormValues;
  apply3dsEscottToken: Escott3dsToken;
  applyOperationCode: string;
  applyNsboSelectedSettlementType: string;
  applyBosSelectedSettlementType: string;
  applyQueryParams: {
    backurl: string;
  };
  iapToCredit3dsFormValues: CreditCard3dsFormValues;
  iapToCredit3dsEscottToken: Escott3dsToken;
  paraviMigration: MergeToken;
  auInit: MergeToken;
  rmActivationLicenseCode: {
    licenseCode: string;
  };
  amazonBundle: {
    mailAddress: string;
    password: string;
    hasCalledMutation?: boolean;
  };
  smsAuthn: {
    // route.ts で初期設定
    tel: string;
    redirectUrl: string;
    cancelUrl: string;
    // start完了後に追記
    inputTel?: string;
    msisdn?: string;
    UUID?: string;
    // verify完了後に追記
    trackingKey?: string;
  };
  // alt-start がセットする。confirm で現在の subscriptionType と一致した場合のみ alt-complete へ遷移
  packAltRoute: SubscriptionTypeInput;
};

/**
 * 型安全なセッションストレージフック
 */
export const useSessionStorageEx = <K extends keyof SessionStorageKeys>(
  key: K,
  initialValue?: SessionStorageKeys[K]
) => {
  const [value, setValue] = useSessionStorage<
    SessionStorageKeys[K] | undefined
  >(key, initialValue);

  return {
    value,
    setValue,
  };
};
